import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ProductSaleAPI {
  URI_V1 = "/v1/product-sales";

  getCompanyId = () => companyAPI.getCompanyManagment().id;

  create = async (data: any) => {
    return await apiService.post(this.URI_V1, {
      ...data,
      companyId: this.getCompanyId(),
    });
  };

  delete = async (saleId: any) => {
    return await apiService.delete(`${this.URI_V1}/${saleId}`);
  };
}